import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-left-pipe', 'ChevronLeftPipe', [["path",{"d":"M7 6v12","key":"svg-0"}],["path",{"d":"M18 6l-6 6l6 6","key":"svg-1"}]]);